import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Body,
  SubmitButton,
  Field,
  Switch,
  FormCadastro,
  GroupField,
  Input,
  InputNumber,
  PageHeader,
  Select,
  Checkbox,
  View,
  DatePicker,
} from '@components';
import { getTarefa, putTarefa, postTarefa, reset } from '@ducks/conectoresTarefas';
import App from '@app';
import styled from 'styled-components';
import moment from 'moment';
import { Diario as LayoutDiario, Intervalo as LayoutIntervalo, Mensal as LayoutMensal, Unica as LayoutUnica, Types } from './TiposExecucao';
import { DATE_FORMATS, formatTimeS, dateToAnsi } from '@utils';

const ViewDescricaoGroupCheckbox = styled(View)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const ViewCheckbox = styled(View)`
  flex-direction: column;
  flex: 1;
  margin-right: 15px;
`;

const GroupCheckboxDias = styled(View)`
  border-radius: 5px;
  border: 1px solid #ddd;
  padding-left: 8px;
  flex-direction: column;
`;

const GroupCheckboxDiasRow = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
`;

const FieldCheckboxDias = styled(Field)`
  margin-bottom: 0;
  margin-left: 0;
`;

const CheckboxStyled = styled(Checkbox)`
  display: flex;
  align-items: center;
`;

const ViewFields = styled(View)`
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
`;

const DtPicker = styled(DatePicker)`
  width: 100%;
`;

const typesTpExecucao = [
  { key: 'INTERVALO', value: 'INTERVALO', title: 'Intervalo' },
  { key: 'DIARIO', value: 'DIARIO', title: 'Diário' },
  { key: 'MENSAL', value: 'MENSAL', title: 'Mensal' },
  { key: 'UNICA', value: 'UNICA', title: 'Execução única' },
];

export default function Cadastro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { idConfiguracao, idFonteDado, id } = useParams();
  const edicao = id !== '-1';
  const [tpLayout, setTpLayout] = useState('');

  const tarefa = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('tarefa'));
  const successTarefa = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('successTarefa'));

  const successPostTarefa = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('successPostTarefa'));
  const successPutTarefa = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('successPutTarefa'));

  const handleReset = () => dispatch(reset());

  useEffect(() => {
    setTpLayout('INTERVALO');
    handleTpLayoutChange();
    form.setFieldsValue({
      ativo: true,
      notificacao: true,
      segunda: true,
      terca: true,
      quarta: true,
      quinta: true,
      sexta: true,
      sabado: true,
      domingo: true,
      tpExecucao: 'INTERVALO',
      dtUltimaExecucao: moment(),
    });
  }, []);

  useEffect(() => {
    if (successPostTarefa || successPutTarefa) {
      handleReset();
      history.goBack();
    }
  }, [successPostTarefa, successPutTarefa]);

  useEffect(() => {
    if (edicao) {
      dispatch(getTarefa(idConfiguracao, idFonteDado, id));
    }
  }, []);

  useEffect(() => {
    if (tarefa && edicao) {
      setTpLayout(tarefa.tpExecucao);
      handleTpLayoutChange();
      form.setFieldsValue(tarefa);
    }
  }, [successTarefa]);

  const getTypesTpExecucao = async () => {
    return typesTpExecucao;
  };

  const handleSubmit = (data) => {
    data.idConfiguracao = parseInt(idConfiguracao);
    data.idFonteDado = parseInt(idFonteDado);

    let object = {};
    let hasAlteracao = false;

    if (edicao) {
      data.id = parseInt(id);

      object.idConfiguracao = data.idConfiguracao;
      object.idFonteDado = data.idFonteDado;
      object.id = data.id;

      const entries = Object.entries(tarefa);
      for (const [key, value] of entries) {
        // eslint-disable-next-line
        if (data[key] != value) {
          object[key] = data[key];
          hasAlteracao = true;
        }
      }
    } else {
      const entries = Object.entries(data);
      for (const [key, value] of entries) {
        object[key] = value;
      }
    }

    if (object.periodoDtExecucao) {
      object.dtInicioExecucao = dateToAnsi(object.periodoDtExecucao[0], DATE_FORMATS.ANSI_DATE, DATE_FORMATS.ANSI_DATE);
      object.dtFimExecucao = dateToAnsi(object.periodoDtExecucao[1], DATE_FORMATS.ANSI_DATE, DATE_FORMATS.ANSI_DATE);

      delete object.periodoDtExecucao;
    } else if (tarefa && object.periodoDtExecucao === null && tarefa.periodoDtExecucao) {
      if (tarefa.periodoDtExecucao[0]) object.dtInicioExecucao = null;
      if (tarefa.periodoDtExecucao[1]) object.dtFimExecucao = null;
    }

    if (object.periodoHrExecucao) {
      object.hrInicioExecucao = formatTimeS(object.periodoHrExecucao[0]);
      object.hrFimExecucao = formatTimeS(object.periodoHrExecucao[1]);
    } else if (tarefa && object.periodoHrExecucao === null && tarefa.periodoHrExecucao) {
      if (tarefa.periodoHrExecucao[0]) object.hrInicioExecucao = null;
      if (tarefa.periodoHrExecucao[1]) object.hrFimExecucao = null;
    }

    delete object.periodoHrExecucao;
    delete object.periodoDtExecucao;

    if (object.dtUltimaExecucao) object.dtUltimaExecucao = dateToAnsi(object.dtUltimaExecucao, DATE_FORMATS.ANSI, DATE_FORMATS.ANSI_S);
    if (object.dtExecucao) object.dtExecucao = dateToAnsi(object.dtExecucao, DATE_FORMATS.ANSI_DATE);
    if (object.hrExecucao) object.hrExecucao = formatTimeS(object.hrExecucao);

    if (edicao) {
      if (hasAlteracao) {
        delete object.idFonteDado;
        dispatch(putTarefa(object));
      } else {
        handleReset();
        history.goBack();
      }
    } else {
      dispatch(postTarefa(object));
    }
  };

  function handleTpLayoutChange() {
    switch (tpLayout) {
      case Types.DIARIO:
        return <LayoutDiario />;
      case Types.INTERVALO:
        return <LayoutIntervalo />;
      case Types.MENSAL:
        return <LayoutMensal />;
      case Types.UNICA:
        return <LayoutUnica />;
      default:
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title="Tarefa" onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <ViewFields>
                <Field label="Descrição" name="ds" rules={[{ required: true, message: 'Informe a descrição' }]}>
                  <Input autoFocus />
                </Field>
              </ViewFields>
              <ViewFields>
                <Field label="Ativo" name="ativo" valuePropName="checked">
                  <Switch />
                </Field>
                <Field label="Notificação" name="notificacao" valuePropName="checked">
                  <Switch />
                </Field>
              </ViewFields>
            </GroupField>
            <GroupField>
              <Field label="Tipo de execução" name="tpExecucao" rules={[{ required: true, message: 'Informe o tipo de execução' }]}>
                <Select
                  form={form}
                  allowClear={false}
                  name="tpExecucao"
                  action={() => getTypesTpExecucao()}
                  placeholder="Selecione um tipo de execução"
                  onChange={(value) => setTpLayout(value)}
                />
              </Field>
              <ViewCheckbox>
                <ViewDescricaoGroupCheckbox>Dias de funcionamento</ViewDescricaoGroupCheckbox>
                <GroupCheckboxDias>
                  <GroupCheckboxDiasRow>
                    <FieldCheckboxDias name="segunda" valuePropName="checked">
                      <CheckboxStyled>Segunda</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="terca" valuePropName="checked">
                      <CheckboxStyled>Terça</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="quarta" valuePropName="checked">
                      <CheckboxStyled>Quarta</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="quinta" valuePropName="checked">
                      <CheckboxStyled>Quinta</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="sexta" valuePropName="checked">
                      <CheckboxStyled>Sexta</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="sabado" valuePropName="checked">
                      <CheckboxStyled>Sábado</CheckboxStyled>
                    </FieldCheckboxDias>
                    <FieldCheckboxDias name="domingo" valuePropName="checked">
                      <CheckboxStyled>Domingo</CheckboxStyled>
                    </FieldCheckboxDias>
                  </GroupCheckboxDiasRow>
                </GroupCheckboxDias>
              </ViewCheckbox>
            </GroupField>
            <GroupField>
              <ViewFields>{handleTpLayoutChange()}</ViewFields>
              <ViewFields>
                <Field
                  label="Última execução"
                  name="dtUltimaExecucao"
                  rules={[{ required: true, message: 'Informe a data da última de execução' }]}
                >
                  <DtPicker format="DD/MM/YYYY HH:mm:ss" showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }} allowClear={false} />
                </Field>
                <Field
                  label="Registro/Lote"
                  name="qtRegistroLote"
                  rules={[{ required: true, message: 'Informe a quantidade de registro por lote' }]}
                >
                  <InputNumber />
                </Field>
              </ViewFields>
            </GroupField>
            <SubmitButton type="success" htmlType="submit" block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
